// Google Storage
export const TRANSCRIPT_SOURCE = 'transcript_source'
export const TRANSCRIPT_TRANSLATION = 'transcript_translation'
export const TRANSCRIPT_TRANSLATION_TIMESTAMPED = 'transcript_translation_timestamped'
export const SOURCE_VIDEO = 'source_video'
export const SOURCE_AUDIO = 'source_audio'


// We should use the package.json proxy instead of this: https://create-react-app.dev/docs/proxying-api-requests-in-development/
// Backend APIs
export const BACKEND_URL = process.env.REACT_APP_SERVER_URL;
export const UPLOAD_FILE_URL = BACKEND_URL + "upload_files/";
export const CHECK_TRANSCRIPT_URL = BACKEND_URL + "check-transcript/";
export const UPLOAD_LINK_URL = BACKEND_URL + "upload_link/";
export const GET_TRANSCRIPT_URL = BACKEND_URL + "transcript/";
export const GET_SIGNED_URL = BACKEND_URL + "signed_url/";
export const CREATE_CHECKOUT_SESSION = BACKEND_URL + 'create-checkout-session/';
export const TRAIN_VOICE_URL = BACKEND_URL + 'training/';

// Event names
export const REFRESH_CONTENT_MANAGER = "refresh_content_manager";

// Firebase collections
export const USER_COLLECTION = "users";
export const CONTENT_COLLECTION = "content";
export const USER_FILE_COLLECTION = "files";
export const JOB_COLLECTION = "jobs";
export const TRAINING_COLLECTION = "training";

// Firebase fields
export const USER_FIELD_CONTENT_IDS = "content_ids";